var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "table-wrap" }, [
      _c(
        "table",
        { staticClass: "feedback-table" },
        [
          _vm._m(0),
          _vm._l(_vm.answerList, function (question, index) {
            return _c("tr", { key: index }, [
              _c(
                "th",
                { staticClass: "text-center", attrs: { scope: "row" } },
                [_vm._v(_vm._s(question.Seq))]
              ),
              _c(
                "td",
                [
                  question.InputType === 1
                    ? _c(
                        "el-select",
                        {
                          model: {
                            value: question.CorrectAnswer,
                            callback: function ($$v) {
                              _vm.$set(question, "CorrectAnswer", $$v)
                            },
                            expression: "question.CorrectAnswer",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: true, label: "是" },
                          }),
                          _c("el-option", {
                            attrs: { value: false, label: "否" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  question.InputType === 2
                    ? _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "number" },
                        model: {
                          value: question.CorrectAnswer,
                          callback: function ($$v) {
                            _vm.$set(question, "CorrectAnswer", $$v)
                          },
                          expression: "question.CorrectAnswer",
                        },
                      })
                    : _vm._e(),
                  question.InputType === 3
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: question.CorrectAnswer,
                            callback: function ($$v) {
                              _vm.$set(question, "CorrectAnswer", $$v)
                            },
                            expression: "question.CorrectAnswer",
                          },
                        },
                        [
                          _c("el-option", { attrs: { value: "A" } }),
                          _c("el-option", { attrs: { value: "B" } }),
                          _c("el-option", { attrs: { value: "C" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  question.InputType === 4
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: question.CorrectAnswer,
                            callback: function ($$v) {
                              _vm.$set(question, "CorrectAnswer", $$v)
                            },
                            expression: "question.CorrectAnswer",
                          },
                        },
                        [
                          _c("el-option", { attrs: { value: "A" } }),
                          _c("el-option", { attrs: { value: "B" } }),
                          _c("el-option", { attrs: { value: "C" } }),
                          _c("el-option", { attrs: { value: "D" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  question.InputType === 5
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: question.CorrectAnswer,
                            callback: function ($$v) {
                              _vm.$set(question, "CorrectAnswer", $$v)
                            },
                            expression: "question.CorrectAnswer",
                          },
                        },
                        [
                          _c("el-option", { attrs: { value: "A" } }),
                          _c("el-option", { attrs: { value: "B" } }),
                          _c("el-option", { attrs: { value: "C" } }),
                          _c("el-option", { attrs: { value: "D" } }),
                          _c("el-option", { attrs: { value: "E" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  question.InputType === 6
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: question.CorrectAnswer,
                            callback: function ($$v) {
                              _vm.$set(question, "CorrectAnswer", $$v)
                            },
                            expression: "question.CorrectAnswer",
                          },
                        },
                        [
                          _c("el-option", { attrs: { value: "A" } }),
                          _c("el-option", { attrs: { value: "B" } }),
                          _c("el-option", { attrs: { value: "C" } }),
                          _c("el-option", { attrs: { value: "D" } }),
                          _c("el-option", { attrs: { value: "E" } }),
                          _c("el-option", { attrs: { value: "F" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  question.InputType === 9
                    ? _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "text" },
                        model: {
                          value: question.CorrectAnswer,
                          callback: function ($$v) {
                            _vm.$set(question, "CorrectAnswer", $$v)
                          },
                          expression: "question.CorrectAnswer",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "td",
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    model: {
                      value: question.Score,
                      callback: function ($$v) {
                        _vm.$set(question, "Score", $$v)
                      },
                      expression: "question.Score",
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "primary", round: "" },
              on: {
                click: function ($event) {
                  return _vm.setLogicTest()
                },
              },
            },
            [_vm._v("儲存")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "text-center", attrs: { scope: "row" } }, [
        _vm._v("題次"),
      ]),
      _c("th", { staticClass: "text-center", attrs: { scope: "row" } }, [
        _vm._v("答案"),
      ]),
      _c("th", { staticClass: "text-center", attrs: { scope: "row" } }, [
        _vm._v("分數"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }